export default "__VITE_PUBLIC_ASSET__74f34f74__"